export class StoreService {

    static new(store, module) {
        const service = new StoreService(module.name, store);        
        service.registerModule(module);               
        return service;
    }

    constructor(name, store) {        
        this.name = name;
        this.store = store;
    }    

    registerModule(module) {
        if (this.store && this.store.state && this.store.state[module.name]) return;                 
        this.store.registerModule(module.name, module);             
    }

    get(element) {
        return this.store.getters[`${this.name}/${element}`];
    }

    async dispatch(action, options) {
        await this.store.dispatch(`${this.name}/${action}`, options);  
    }
}